module.exports = __webpack_public_path__ + "img/track.70570798.svg";